module.exports = __webpack_public_path__ + "img/12.249a3529.jpg";